import Component from '@glimmer/component';

export default class PlaylistListTabsComponent extends Component {}
